module.exports = __webpack_public_path__ + "img/20_-Hemorrhoid.0b0e821e.png";